import TooltipButton from './TooltipButton';

export { TooltipButton };
export default TooltipButton;
